import { PresetLaneSicsSuggestion } from "../../hooks/react-query/settings/outbound/usePresetLaneSicsSuggestion";

export const mockPresetLanesSicsSuggestionList = {
  default: {
    associatedSics: [
      {
        code: "ATL",
      },
      {
        code: "ATM",
      },
      {
        code: "AUB",
      },
      {
        code: "CHT",
      },
      {
        code: "DAL",
      },
      {
        code: "DEN",
      },
      {
        code: "DFW",
      },
      {
        code: "HTX",
      },
      {
        code: "JAX",
      },
      {
        code: "LAX",
      },
      {
        code: "LRD",
      },
      {
        code: "MIS",
      },
      {
        code: "NAS",
      },
      {
        code: "NAS-AVRT",
      },
      {
        code: "NAS-VOLT",
      },
      {
        code: "ONT",
      },
      {
        code: "PHX",
      },
      {
        code: "PHX-ACDO",
      },
      {
        code: "PHX-DDPP",
      },
      {
        code: "PHX-OAKH",
      },
      {
        code: "SAT",
      },
      {
        code: "SFO",
      },
      {
        code: "SFO-AKFI",
      },
      {
        code: "SFO-WCHT",
      },
      {
        code: "SLC-DLDS",
      },
      {
        code: "VIS",
      },
    ],
    otherSics: [
      "ABE",
      "AFT",
      "AFW",
      "ALB-SXCY",
      "ATB",
      "ATB-SEFL",
      "ATC",
      "ATL-BUOH",
      "ATL-JKSI",
      "ATS",
      "AWE",
      "BDL-RXIC",
      "BOS",
      "BOS-LAXV",
      "BTR",
      "BUF-SXCY",
      "BWI",
      "BWI-PDXE",
      "CHI",
      "CHI-SUON",
      "CHM-QTLI",
      "CHM-WARD",
      "CHT-AVRT",
      "CLE-PITD",
      "CLE-USCO",
      "CLE-WARD",
      "CMH",
      "COL",
      "COL-USCO",
      "CVG-ABNE",
      "CVG-USCO",
      "DAL-AGCE",
      "DEN-DLDS",
      "DET-DAFG",
      "DFW-AGCE",
      "DSE",
      "DSM-DHRN",
      "DTW",
      "DTW-DAFG",
      "ELP-SEFL",
      "EWR",
      "HAR",
      "HAR-WARD",
      "HON-ALHF",
      "HOU",
      "HOU-SEFL",
      "HOU-TEXX",
      "HRC",
      "HVN",
      "HZL-CENC",
      "IND",
      "IND-DAFG",
      "IND-PITD",
      "ISP-OTFS",
      "KMT",
      "LBF-NEBT",
      "LGA-OTTF",
      "LGA-SLEF",
      "LIT-DHRN",
      "LKL-STQC",
      "LOU-DAFG",
      "LRD-RIOG",
      "MDW-CXIT",
      "MEM",
      "MIA-AVRT",
      "MIA-SEFL",
      "MIB",
      "MSN-SUON",
      "NJC-PYLE",
      "NLD-ENTG",
      "NOR-PITD",
      "OHN",
      "OHV",
      "ONT-OAKH",
      "ONT-TONI",
      "ORD",
      "ORD-SUON",
      "ORH-RXIC",
      "ORL",
      "OSH",
      "PDX",
      "PDZ",
      "PDZ-DLDS",
      "PER-DHRN",
      "PGH",
      "PGH-PYLE",
      "PME",
      "RIC",
      "RIC-AVRT",
      "RIS-DHRN",
      "SCK-TONI",
      "SCR-SXCY",
      "SEA-DLDS",
      "SFW-WCHT",
      "SHO-SEFL",
      "SJC-WCHT",
      "SLC",
      "SOU-PYLE",
      "STL",
      "STL-DAFG",
      "STU-DHRN",
      "SVL",
      "SWE",
      "SYR-PYLE",
      "SYR-SXCY",
      "TEB",
      "TOL-DAFG",
      "TOR-SZTG",
      "TUL-AGCE",
      "UCA",
      "WCH-PYLE",
      "WSH-PITD",
      "YRK-PYLE",
    ],
  },
} as const satisfies Record<string, PresetLaneSicsSuggestion>;
